import moment from 'moment'
import { createStructuredSelector } from 'reselect'

import { getDateFormat, withRouter } from 'i18n/utils'

import { newsSelector, pagingSelector, loadingSelector } from '../selectors'

const NewsListItem = ({ date, title, excerpt, image, category, slug }) => {
    const formattedDate = moment(date).format(getDateFormat())
    const url = `news/${category ? category.slug : 'uncategorized'}/${slug}`

    const html = { __html: excerpt }

    return (
        <div className="row article m-0">
            <div className="col-lg-3 col-sm-12 p-0 image">
                <Image image={image} title={title} />
            </div>

            <div className="col-lg-9 col-sm-12 summary">
                <span className="date">
                    <i className="category icon-4" />
                    <T>news.label.published</T> {formattedDate}
                </span>

                <h2>
                    <Link to={url} title={title}>
                        {title}
                    </Link>
                </h2>
                <p className="excerpt" dangerouslySetInnerHTML={html} />

                <span className="more-link">
                    <Link to={url} title={title}>
                        <T>news.label.read.more</T>
                        <i className="arrow-right" />
                    </Link>
                </span>
            </div>
        </div>
    )
}

const $MoreButton = ({
    location: {
        query: { search, page },
    },
}) => (
    <Link
        className="btn btn btn-outline-primary more-btn"
        to={{ search: { search, page: page ? parseInt(page) + 1 : 2 } }}>
        <T>news.label.more.news</T>
    </Link>
)

const MoreButton = withRouter($MoreButton)

const NewsList = ({ category, loading, news, paging }) => (
    <div className="col-12 articles p-0">
        {news.map(item => (
            <NewsListItem {...item} category={category} key={item.id} />
        ))}

        {loading && <div className="loading" />}
        {!loading && news.length === 0 && (
            <div className="no-results">
                <T>news.label.no.results</T>
            </div>
        )}
        {!loading && paging && paging.page < paging.totalPages && <MoreButton />}
    </div>
)

export default connect(
    createStructuredSelector({
        news: newsSelector,
        paging: pagingSelector,
        loading: loadingSelector,
    })
)(NewsList)
